module.exports = __webpack_public_path__ + "img/fm.050984fa.svg";